/**
 * Copyright (c) 2025 AI(R) Poetry. All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Poetry type templates for prompt construction
 */

export const SONNET_TEMPLATE = `
It should follow the traditional sonnet structure:
- 14 lines exactly.
- Lines should be in iambic pentameter (10 syllables per line with alternating unstressed and stressed syllables).
- Follows a strict rhyme scheme of ABAB CDCD EFEF GG (English or Shakespearean sonnet) or ABBA ABBA CDC DCD (Italian or Petrarchan sonnet).
- Contains a volta (turn or shift in thought) typically around line 9.
- Develops a single theme or idea, with the final couplet (in Shakespearean) or sestet (in Petrarchan) providing resolution or a new perspective.
`;

export const ODE_TEMPLATE = `
It should follow the characteristics of a classical ode:
- Elevated language and formal tone.
- Addressing a specific subject directly.
- Contains stanzas of similar length and structure.
- Develops a serious theme with dignity and emotional intensity.
- Celebrates or contemplates its subject with reverence.
- Uses rich imagery and metaphors.
- Maintains a consistent, dignified rhythm.
`;

export const FREE_VERSE_TEMPLATE = `
It should embody the essence of free verse:
- No fixed metrical pattern or rhyme scheme.
- Line breaks and stanza divisions based on natural speech patterns or for emphasis.
- Uses rhythm organically rather than following prescribed patterns.
- Focuses on the natural flow of language.
- May vary in line length to create emphasis or reflect content.
- Employs literary devices like imagery, metaphor, and symbolism.
- Structure supports the poem's meaning rather than following traditional forms.
`; 